<template>
    <common-table :table-columns="tableColumns" :url="url" :operate="operate" :searchs="[]" :form-fields="formFields" :permission="[]"></common-table>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    export default {
        name: "QueueTask",
        components: {CommonTable},
        data(){
            return {
                url: {
                    get: '/system/queue/task',
                },
                tableColumns: [{
                    field: 'capitalStatisticsConsume',
                    label: '资金统计',
                    show: true,
                    width: '',
                }, {
                    field: 'cloudMiningConsume',
                    label: '生成云矿',
                    show: true,
                    width: '',
                }, {
                    field: 'financeConsume',
                    label: '财务统计',
                    show: true,
                    width: '',
                }, {
                    field: 'rebateConsume',
                    label: '充值返利',
                    show: true,
                    width: '',
                }, {
                    field: 'rechargeCompleteConsume',
                    label: '充值查询',
                    show: true,
                    width: '',
                }, {
                    field: 'scoreConsume',
                    label: '积分统计',
                    show: true,
                    width: '',
                }, {
                    field: 'transferRecordConsume',
                    label: '转账记录',
                    show: true,
                    width: '',
                }, {
                    field: 'userRepairConsume',
                    label: '用户修复',
                    show: true,
                    width: '',
                }, {
                    field: 'walletBalanceConsume',
                    label: '会员余额归集',
                    show: true,
                    width: '',
                }, {
                    field: 'cloudFlareConsume',
                    label: 'CF注册',
                    show: true,
                    width: '',
                }, {
                    field: 'userWalletCollectionConsume',
                    label: '余额归集',
                    show: true,
                    width: '',
                }],
                operate: [],
                formFields: {
                    toTree: false,
                    model: [],
                }
            }
        }
    }
</script>

<style scoped>

</style>
